import Vue from 'vue'
import Router from 'vue-router'

// 页面组件导入
import Login from '@/components/login'
import TJCloudLogin from '@/components/TJCloudLogin'    //天机云登录页

// import LoginCopy from '@/components/logincopy'
import Index from '@/components/index'
import Header from '@/components/PublicAssembly/header'
import LeftNavigation from '@/components/PublicAssembly/leftNavigation'
import Organize from "@/components/PublicAssembly/organize"
import Pagination from '@/components/PublicAssembly/pagination'
import Dashboard from '@/components/Dashboard/Dashboard'
import IndexEdit from '../components/IndexEdit/indexEdit'
import IndexEditShow from '../components/IndexEditShow/indexEditShowBox'
import MapEditor from '../components/MapEditor/index/indexMapEditor'
import DataAnalytical from '../components/DataAnalytical/indexAnalytical'

import IntelligentPrediction from '../components/IntelligentPrediction/index'
import MultiModel from '../components/IntelligentPrediction/model'
import MapEditorPreview from '../components/MapEditor/Preview/rowPreviewMap'
import Company from '@/components/Company/company'
import Overviews from '@/components/overviews/overviews'
// import Demo from '@/components/PublicAssembly/demo'
import Parameter from '@/components/SetUp/parameter'
import Category from '@/components/SetUp/category'
import Material from '@/components/SetUp/material'
import SystemNotice from '@/components/SetUp/SystemNotice'
import DeviceSim from '@/components/SetUp/deviceSim'
import UserList from '@/components/User/userList'
import RoleList from '@/components/Role/roleList'
import UserProfile from '@/components/User/UserProfile'
import ProductList from '@/components/Product/productList'
import NoticeRuleList from "@/components/NoticeRule/NoticeRuleList"
import Message from '@/components/Message/Message'
import ProductLog from '@/components/PlatformLog/productLog'
import UserLog from '@/components/PlatformLog/userLog'
import Dataset from '@/components/Dataset/dataset'
import Backups from '@/components/backups/index'
import CreatedCharts from '@/components/Dataset/CreatedCharts'
import Devops from '@/components/BigScreen/Devops'
// import DevopsPreview from '@/components/BigScreen/ShowScreen'
// import DevopsAdd from '@/components/BigScreen/DevopsAdd'
// import DevopsEdit from '@/components/BigScreen/DevopsEdit'
import FormsList from '@/components/ReportForms/FormsList'
import ReportForms from '@/components/ReportForms/ReportForms'
import MeterReading from '@/components/ReportForms/meterReading'
import Workorder from '@/components/WorkOrder/workorder'

//企业运维组件
import ConsoleIndex from "@/components/consoleIndex"
import ConsoleHeader from "@/components/PublicAssembly/consoleHeader"
import DeviceList from "@/components/CompanyConsole/Device/deviceList"
import DeviceAlarmList from "@/components/CompanyConsole/DeviceAlarm/DeviceAlarmList"
import ServicePlan from '@/components/CompanyConsole/ServicePlan/ServicePlan'
import TaskPlan from "@/components/CompanyConsole/TaskPlan/taskPlan"
import CompanyLog from '@/components/CompanyConsole/CompanyLog/CompanyLog'
// import IndexEditor from "@/components/indexEditor/pages/index"
const IndexEditor = ()=>import("@/components/indexEditor/pages/index")

// 能源管理组件
import EnergyRouter from "@/components/PublicAssembly/EnergyRouter"
import MeterReport from "@/components/Energy/MeterReport"
import RatioReport from "@/components/Energy/RatioReport"
import ElectricMonitor from "@/components/Energy/ElectricMonitor"
import EnergyConfig from "@/components/Energy/EnergyConfig"
import EnergyDataConfig from "@/components/Energy/EnergyDataConfig"
import EnergyIndex from "@/components/Energy/index"

// 公众号组件
// import mobileIndex from '@/components/mobileIndex'
// import userDetail from '@/components/MobileComponents/user/userDetail'
// import MobMessage from '@/components/MobileComponents/message/message'
// import MobConsoleIndex from '@/components/MobileComponents/companyconsole/consoleIndex'
// import WarningDetails from "@/components/MobileComponents/companyconsole/warningDetails"
// import DeviceDetails from "@/components/MobileComponents/companyconsole/deviceDetails"
// import MobDashboard from '@/components/MobileComponents/Dashboard/MobDashboard'
// import BigScreen from '@/components/MobileComponents/BigScreen/index'
// import BigScreenPreview from '@/components/MobileComponents/BigScreen/preview'
// import MobPreview from "@/components/MapEditor/Preview/previewBox"
// import newMould from '../components/MobileComponents/companyconsole/newMould'

//首页编辑器
const Editor = resolve => require(['@/pages/Editor/index.vue'], resolve)
// const indexPreview = resolve => require(['@/pages/preview/index.vue'], resolve)
import indexPreview from "@/pages/preview/index"
// const pie3d = resolve => require(['@/pages/Editor/pie3d.vue'], resolve)



Vue.use(Router);

export default new Router({
    // mode: 'history',
    mode: 'hash',
    base: '/dist',
    routes: [
        { path: '', component: Login, name: 'Login' },      //登录
        { path: '/login', component: Login, name: 'Login' },      //登录
        { path: '/TJCloudLogin', component: TJCloudLogin, name: 'TJCloudLogin' },      //天机云登录
        // {path:'/mobile/preview2',component:MobPreview,name:'MobDashboard'},          //运维组态
        { path: '/index', component: Index, name: 'Index' },        //首页
        { path: '/header', component: Header, name: 'Header' },     //头部
        { path: '/leftNavigation', component: LeftNavigation, name: 'LeftNavigation' },     //左侧导航菜单
        { path: '/organize',component:Organize,name:'Organize'},    //组织
        { path:'/IndexEditor',component:IndexEditor,name:"IndexEditor"},
        { path: '/pagination',component:Pagination,name:'Pagination'},          //分页
        { path: '/index.html', component: Index, name: 'Index',children:[       //首页
            {path:'/company', component: Company, name:'Company'},              //企业管理
            {path:'/parameter', component:Parameter, name:'Parameter'},         //平台设置 - 参数设置
            {path:'/category', component:Category, name:'Category'},            //平台设置 - 类别设置
            {path:'/material', component:Material, name:'Material'},            //平台设置 - 设备素材
            {path:'/deviceSim', component:DeviceSim, name:'DeviceSim'},         //平台设置 - sim卡管理
            {path:'/systemNotice', component:SystemNotice, name:"SystemNotice"},               //平台公告
            {path:'/userList', component:UserList, name:'UserList'},            //用户管理
            {path:'/userProfile', component:UserProfile, name:'UserProfile'},   //用户中心
            {path:'/roleList', component:RoleList, name:'RoleList'},            //角色管理
            {path:'/productList', component:ProductList, name:'ProductList'},   //产品管理
            {path:'/NoticeRuleList',component:NoticeRuleList, name:'NoticeRuleList'},   //通知规则
            {path:'/Message', component:Message, name:"Message"},               //消息盒子
            {path:'/productLog', component:ProductLog, name:"ProductLog"},      //平台日志
            {path:'/userLog', component:UserLog, name:"UserLog"},               //用户日志
            {path:'/dataset', component:Dataset, name:"Dataset"},               //数据集
            {path:'/dataset/createdCharts', component:CreatedCharts, name:"CreatedCharts"},	//数据集 - 生成报表
            {path:'/FormsList',component:FormsList,name:"FormsList"},           //报表 - 列表
            {path:'/ReportForms',component:ReportForms,name:"ReportForms"},     //报表 - 查看报表
            {path:'/meterReading',component:MeterReading,name:"MeterReading"},   //抄表 - 预览
            {path:'/Overviews', component:Overviews, name:"Overviews"},         //运维中心
            {path:'/Dashboard', component:Dashboard, name:"Dashboard"},         //运维中心
            {path:'/Devops', component:Devops, name:"Devops"},					//运维大屏
            {path:'/backups', component:Backups, name:"Backups"},					//备份恢复
            {path:'/IntelligentPrediction', component:IntelligentPrediction, name:"IntelligentPrediction"},		
            {path:'/MultiModel', component:MultiModel, name:"MultiModel"},			//智能预测
            {path:'/Workorder', component:Workorder, name:"Workorder"},					//工单管理
            // {path:'/DevopsPreview', component:DevopsPreview, name:"DevopsPreview"},	//运维大屏展示
            // {path:'/DevopsAdd', component:DevopsAdd, name:"DevopsAdd"},			//运维大屏新增
            // {path:'/DevopsEdit', component:DevopsEdit, name:"DevopsEdit"},			//运维大屏编辑
        ]},
        // { path: '/demo', component: Demo, name: 'Demo' },
        { path: '/Editor', name: 'Editor', component: Editor },
        { path: '/indexPreview', name: 'indexPreview', component: indexPreview },
        // { path: '/pie3d', name: 'pie3d', component: pie3d },
        //企业运维组件
        { path: '/consoleHeader', component: ConsoleHeader, name: 'ConsoleHeader' },    //企业运维头部
        { path: '/consoleIndex', component: ConsoleIndex, name: 'ConsoleIndex', children:[
            {path:'/CompanyConsole/IndexEditShow', component: IndexEditShow, name: 'IndexEditShow',meta:{ keepAlive: true, updataMark: false,/*判断是否在首页编辑中更新过*/} },        //首页
            {path:'/CompanyConsole/deviceList', component:DeviceList, name:'DeviceList'},   //设备管理
            {path:'/CompanyConsole/DeviceAlarmList', component:DeviceAlarmList, name:'DeviceAlarmList'},   //报警管理
            {path:'/CompanyConsole/ServicePlan', component:ServicePlan, name:'ServicePlan'},    //维保记录
            {path:'/CompanyConsole/TaskPlan', component:TaskPlan, name:'TaskPlan'},   //计划任务
            {path:'/CompanyConsole/CompanyLog', component:CompanyLog, name:'CompanyLog'},       //企业日志
            {path:'/CompanyConsole/userProfile', component:UserProfile, name:'UserProfile'},   //用户中心
            {path:'/CompanyConsole/Message', component:Message, name:"Message"},               //消息盒子
            { path: '/CompanyConsole/IndexEdit', component: IndexEdit, name: 'IndexEdit' },        //首页编辑
            { path: '/CompanyConsole/mapEditor', component: MapEditor, name: 'MapEditor' },        //编辑器
            { path: '/CompanyConsole/mapEditorPreview', component: MapEditorPreview, name: 'MapEditorPreview' },        //编辑器预览
            { path: '/CompanyConsole/DataAnalytical', component: DataAnalytical, name: 'DataAnalytical' },//数据分析
            { path: '/CompanyConsole/indexPreview', name: 'indexPreview', component: indexPreview },      //新的首页大屏

            // 能源管理组件
            { path: '/Energy',component: EnergyRouter,name: "EnergyRouter",children:[
              { path: '/Energy/MeterReport', component: MeterReport, name: 'MeterReport',},        //抄表记录
              { path: '/Energy/RatioReport', component: RatioReport, name: 'RatioReport' },        //环比报表
              { path: '/Energy/ElectricMonitor', component: ElectricMonitor, name: 'ElectricMonitor' },   //电气监控
              { path: '/Energy/EnergyConfig', component: EnergyConfig, name: 'EnergyConfig' },   //系统参数配置
              { path: '/Energy/EnergyDataConfig', component: EnergyDataConfig, name: 'EnergyDataConfig' },   //数据源配置
              { path: '/Energy/index', component: EnergyIndex, name: 'EnergyIndex'},   //数据源配置
            ]}


        ] },    //企业运维首页

        // // 移动端
        // {path:'/mobileIndex',component:mobileIndex,name:'mobileIndex',children:[    //公众号组件
        //     {path:'/mobile/userDetails',component:userDetail,name:"userDetail"},    //用户信息
        //     {path:'/mobile/message',component:MobMessage,name:'MobMessage'},        //消息
        //     {path:'/mobile/consoleIndex',component:MobConsoleIndex,name:'MobConsoleIndex'}, //企业运维
        //     {path:'/mobile/warningDetails',component:WarningDetails,name:'WarningDetails'}, //报警详情
        //     {path:'/mobile/deviceDetails',component:DeviceDetails,name:'DeviceDetails'},    //设备详情
        //     {path:'/mobile/dashboard',component:MobDashboard,name:'MobDashboard'},          //运维中心
        //     {path:'/mobile/preview',component:MobPreview,name:'MobDashboard'},          //运维组态
        //     {path:'/mobile/screenShow',component:BigScreen,name:'BigScreen'},          //运维大屏
        //     {path:'/mobile/screenPreview',component:BigScreenPreview,name:'BigScreenPreview'}, //运维大屏展示
        // ]}
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js